import { UsersFilters } from "types/users";

export const convertFiltersToRaw = (filters: UsersFilters) => {
  return {
    skills: filters.skills,
    languages: filters.languages,
    min_rate: filters.rateFrom || null,
    max_rate: filters.rateTo || null,
    location_id: filters.locationId || null,
    location_name: filters.locationSearch || null,
    min_stars: Number(filters.rating) || null,
    is_online: filters.isOnline,
    sorting_options: filters.sorting ? {
      ...(filters.sorting.by_rate !== undefined ? { by_rate: true, direction_desc: !filters.sorting.by_rate } : {}),
      ...(filters.sorting.by_avg_stars !== undefined ? { by_avg_stars: true, direction_desc: !filters.sorting.by_avg_stars } : {}),
    } : null
  };
};
